<template>
    <!-- <div> -->
        <!-- <div class="scrollable only-y" v-loading="loadingChart"> -->
			<!-- <el-button @click="renderChart">Click</el-button> -->
            <div v-if="!showAlert" v-loading="loadingChart" style="width:auto">
                <div class="card-base bg-accent card-shadow--medium p-10">
                    <h2 class="white-text mv-0 mt-5 animated fadeInDown">Whatsapp Overview</h2>
                    <h3 class="mt-0 mb-40 white-text o-050 animated slideInUp">Total Sent Message</h3>
                    <div class="chart" v-echarts="chartOption"></div>
                </div>
                <br>
                <div class="card-base bg-accent card-shadow--medium p-10">
                    <h2 class="white-text mv-0 mt-5 animated fadeInDown">Whatsapp Overview</h2>
                    <h3 class="mt-0 mb-40 white-text o-050 animated slideInUp">Delivered Message</h3>
                    <div class="chart" v-echarts="chartOption1"></div>
                </div>
                <br>
                <div class="card-base bg-accent card-shadow--medium p-10">
                    <h2 class="white-text mv-0 mt-5 animated fadeInDown">Whatsapp Overview</h2>
                    <h3 class="mt-0 mb-40 white-text o-050 animated slideInUp">Failed Message</h3>
                    <div class="chart" v-echarts="chartOption2"></div>
                </div>
            </div>
            <el-alert title="Info" type="info" :closable="false" description="No Data" show-icon v-else></el-alert>
        <!-- </div> -->
    <!-- </div> -->
</template>
<script>
import V_Echarts from '../../directives/echarts';
import echarts from 'echarts'
import 'echarts/lib/component/polar'
const moment = require('moment')

export default {
    props: {
        messages: {
            type: Array
        },
        loadingChart: {
            type: Boolean
        },
        showAlert: {
            type: Boolean
        },
        outbond: {
            type: Object,
        },
        hsm: {
            type: Object
        },
        tanggal: {
            type: Array
        }
    },
    directives: {
        'echarts': V_Echarts
	},
    data() {
        return {
            paginateReport: 1,
            currentPage: 1,
            total: 0,
            today: moment().format('DD MMM YYYY'),
			textSuccess: [0],
			textFail: [0],
			textTotal: [0],
			image: {
				success: [0],
				fail: [0],
				total: [0]
			},
			document: {
				success: [0],
				fail: [0],
				total: [0]
			},
			audio: {
				success: [0],
				fail: [0],
				total: [0]
			},
            chartOption: {
				responsive: true,
				maintainAspectRatio: false,
                // backgroundColor: "#FFF",
                areaColor: "#FFF",
                grid: {
					show: false,
					left: '20px',
					right: '50px',
					bottom: '20px',
					top: '20px',
					containLabel: true
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					}
				},
				legend: {
					show: false,
					data: ['line', 'bar'],
					textStyle: {
						color: '#ccc'
					}
				},
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : [0],
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(255,255,255,0.5)'
                            }
                        }
                    }
                ],
                yAxis : [
                    {
						type: 'value',
                        splitLine: {show: false},
						axisLine: {
							lineStyle: {
								color: 'rgba(255,255,255,0.5)'
							}
						}
                    }
                ],
                series : [
                    {
                        name:'Total Outbond Message',
						type:'line',						
						smooth: true,
						showAllSymbol: true,
						symbol: 'emptyCircle',
						symbolSize: 10,
						lineStyle: {
							color: '#fff'
						},
						itemStyle: {
							color: '#fff', 
							borderColor: '#5f8fdf',
							borderWidth: 3
						},
						areaStyle: {
							color: 'rgba(255,255,255,0.2)'
						},
						animationDuration: 2800,
						animationEasing: 'cubicInOut',
                        data: [0]
					},
					{
                        name:'Total Notification Message',
						type:'line',						
						smooth: true,
						showAllSymbol: true,
						symbol: 'emptyCircle',
						symbolSize: 10,
						lineStyle: {
							color: '#f98643'
						},
						itemStyle: {
							color: '#f98643', 
							borderColor: '#5f8fdf',
							borderWidth: 3
						},
						areaStyle: {
							color: 'rgba(255,255,255,0.2)'
						},
						animationDuration: 2800,
						animationEasing: 'cubicInOut',
                        data: [0]
					}
                ]
			},
			chartOption1: {
				responsive: true,
				maintainAspectRatio: false,
                // backgroundColor: "#FFF",
                areaColor: "#FFF",
                grid: {
					show: false,
					left: '20px',
					right: '50px',
					bottom: '20px',
					top: '20px',
					containLabel: true
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					}
				},
				legend: {
					show: false,
					data: ['line', 'bar'],
					textStyle: {
						color: '#ccc'
					}
				},
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : [0],
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(255,255,255,0.5)'
                            }
                        }
                    }
                ],
                yAxis : [
                    {
						type: 'value',
                        splitLine: {show: false},
						axisLine: {
							lineStyle: {
								color: 'rgba(255,255,255,0.5)'
							}
						}
                    }
                ],
                series : [
                    {
                        name:'Delivered Outbond Message',
						type:'line',						
						smooth: true,
						showAllSymbol: true,
						symbol: 'emptyCircle',
						symbolSize: 10,
						lineStyle: {
							color: '#fff'
						},
						itemStyle: {
							color: '#fff', 
							borderColor: '#5f8fdf',
							borderWidth: 3
						},
						areaStyle: {
							color: 'rgba(255,255,255,0.2)'
						},
						animationDuration: 2800,
						animationEasing: 'cubicInOut',
                        data: [0]
					},
					{
                        name:'Delivered Notification Message',
						type:'line',						
						smooth: true,
						showAllSymbol: true,
						symbol: 'emptyCircle',
						symbolSize: 10,
						lineStyle: {
							color: '#f98643'
						},
						itemStyle: {
							color: '#f98643', 
							borderColor: '#5f8fdf',
							borderWidth: 3
						},
						areaStyle: {
							color: 'rgba(255,255,255,0.2)'
						},
						animationDuration: 2800,
						animationEasing: 'cubicInOut',
                        data: [0]
					}
                ]
			},
			chartOption2: {
				responsive: true,
				maintainAspectRatio: false,
                // backgroundColor: "#FFF",
                areaColor: "#FFF",
                grid: {
					show: false,
					left: '20px',
					right: '50px',
					bottom: '20px',
					top: '20px',
					containLabel: true
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					}
				},
				legend: {
					show: false,
					data: ['line', 'bar'],
					textStyle: {
						color: '#ccc'
					}
				},
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : [0],
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(255,255,255,0.5)'
                            }
                        }
                    }
                ],
                yAxis : [
                    {
						type: 'value',
                        splitLine: {show: false},
						axisLine: {
							lineStyle: {
								color: 'rgba(255,255,255,0.5)'
							}
						}
                    }
                ],
                series : [
                    {
                        name:'Failed Outbond Message',
						type:'line',						
						smooth: true,
						showAllSymbol: true,
						symbol: 'emptyCircle',
						symbolSize: 10,
						lineStyle: {
							color: '#fff'
						},
						itemStyle: {
							color: '#fff', 
							borderColor: '#5f8fdf',
							borderWidth: 3
						},
						areaStyle: {
							color: 'rgba(255,255,255,0.2)'
						},
						animationDuration: 2800,
						animationEasing: 'cubicInOut',
                        data: [0]
					},
					{
                        name:'Failed Notification Message',
						type:'line',						
						smooth: true,
						showAllSymbol: true,
						symbol: 'emptyCircle',
						symbolSize: 10,
						lineStyle: {
							color: '#f98643'
						},
						itemStyle: {
							color: '#f98643', 
							borderColor: '#5f8fdf',
							borderWidth: 3
						},
						areaStyle: {
							color: 'rgba(255,255,255,0.2)'
						},
						animationDuration: 2800,
						animationEasing: 'cubicInOut',
                        data: [0]
					}
                ]
			},
        }
    },
    methods: {
        formatDate(val, format){
            return moment(val).local().format(format)
        },
        renderChart(){
            // creat a fresh object with properties from the original object
            var newChartOption = Object.assign({}, this.chartOption);
            var newChartOption1 = Object.assign({}, this.chartOption1);
            var newChartOption2 = Object.assign({}, this.chartOption2);
            
            // modify properties of the new object
            newChartOption.xAxis[0].data = this.tanggal
            newChartOption.series[0].data = this.outbond.total
            newChartOption.series[1].data = this.hsm.total
            
            newChartOption1.xAxis[0].data = this.tanggal
            newChartOption1.series[0].data = this.outbond.success
            newChartOption1.series[1].data = this.hsm.success

            newChartOption2.xAxis[0].data = this.tanggal
            newChartOption2.series[0].data = this.outbond.fail
            newChartOption2.series[1].data = this.hsm.fail
        }
    },
    mounted() {
        
    },
    watch: {
        tanggal: function(){
            this.renderChart()
        }
    }
}
</script>

